import ChannelMgr from "@/Fwk/Channel/ChannelMgr";
import {KitTrack} from "../Track/KitTrack";
import {AdjustAttr} from "./AdjustAttr";
import {AdjustBase} from "./AdjustBase";
import {JsonData} from "@/Fwk/Kit/JsonData";

/// <author>xiexingwu</author>
export class AdjustWeb extends AdjustBase {

    Init(onChangedAction: () => void) {
        if (onChangedAction != null) this.AddListener(onChangedAction);
        KitTrack._task.AddTask(0.5, ()=>{this.Loop()}, "webAdjust", -1);
    }

    private Loop() {
        const time = new Date().getTime();
        let attrJson: string = ChannelMgr.getAdjustAttrObj;
        if (!attrJson){
            return;
        }
        if (attrJson && time - this.startTime <= 30000) {
            return;
        }
        KitTrack._task.RemoveTask("webAdjust");
        this.OnAttr(new AdjustAttr(attrJson));
    }

    override GetAdjustAttribution() {
        let attrJson = ChannelMgr.getAdjustAttrObj;

        if (!attrJson) {
            return;
        }
        this.OnAttr(new AdjustAttr(attrJson));
    }

    AdjustEvent(token: string, dic: Map<string, string>) {
        const evn = new JsonData();
        // evn.put("token", token);
        if (dic != null) {
            dic.forEach((item,key)=>{
                evn.put(key, item ?? "");
            })
        }

        ChannelMgr.trackEvent({
            eventToken: "{YourEventToken}",
            ...dic
        })
    }

    trackAdjustEvent(token: string, revenue: number) {
        const evn = new JsonData();
        evn.put("revenue", revenue);
        evn.put("currency", "USD");
        ChannelMgr.trackEvent({
            eventToken: "{YourEventToken}",
            ...evn
        });
    }
}
